const body = document.querySelector('body');

async function updateShippingBar() {
  try {
    const res = await fetch("/?section_id=shipping-bar-new");
    const text = await res.text();
   
    // console.log('AJAX response:', text);
    const html = document.createElement("div");
    html.innerHTML = text;

    const newBox = html.querySelector(".promo-banner").innerHTML;
  
    document.querySelector(".promo-banner").innerHTML = newBox;
    
  
    
  } catch (error) {
    // console.log('Error updating shipping bar:', error);
  }
}

function changePriceFormat(){
 document.addEventListener('DOMContentLoaded', (event) => {
    // Wait a bit to ensure all dynamic content is loaded
    setTimeout(() => {
        let elements = document.querySelectorAll('.cart-drawer-form .money');

        elements.forEach(element => {
            let newValue = element.innerHTML.replace(/(\.\d{2})$/, (match, p1) => {
                return p1 === ".00" ? "" : p1;
            });
            let currency = element.getAttribute('data-currency');
            element.innerHTML = newValue + " " + currency;

            // Update data attributes to match the new value
            element.setAttribute('data-currency-original', newValue + " " + currency);
            element.setAttribute('data-currency-aud', newValue + " " + currency);

            //console.log(`Updated money element(update item): ${element.innerHTML}`, element);
        });

      
    }, 500);  // Adjust the delay as necessary
});


}

function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  DisplayAddingAnimation('none', 'Add to Bag');
  body.style.overflow = 'hidden';
   const stickyspinner = document.querySelector('.prodcta-sticky_variant-list .spinner');
     if (stickyspinner) {
        stickyspinner.style.display = 'none';
      }
   const stickyspinnerMob = document.querySelector('.mobile-button.only-mobile .spinner');
     if (stickyspinnerMob) {
        stickyspinnerMob.style.display = 'none';
      }
}

function closeCartDrawer() {
  document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
  body.style.overflow = 'auto';
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart_count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  console.log("res",res)
  const text = await res.text();
  console.log("text",text)
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;
  
  addCartDrawerListeners();
  await ensureSlickInitialized(); // Ensure Slick is loaded and initialized after updating the cart drawer
}

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll("button.cart-drawer-item-remove")
    .forEach((button) => {
     
      button.addEventListener("click", async () => {
         button.disabled = true;
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement;
        const key = button.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = 0;

        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        await updateCartDrawer();
        await updateShippingBar();
        changePriceFormat();
         button.disabled = false;
      });
    });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();

function DisplayAddingAnimation(action, text) {
  const addToCartButton = document.querySelector('.product__atc-btn');
  if (addToCartButton) {
    addToCartButton.querySelector('span[data-add-to-cart-text]').textContent = text;
  }
  const spinner = document.querySelector('.product__btn-container .spinner');
  if (spinner) {
    spinner.style.display = action;
  }
}

// document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();
//      //  const stickyspinner = document.querySelector('.prodcta-sticky_variant-list .spinner');
//      // if (stickyspinner) {
//      //    stickyspinner.style.display = 'block';
//      //    }
    
//     // Submit form with ajax
//     await fetch("/cart/add", {
//       method: "post",
//       body: new FormData(form),
//     });

//     // Get cart count
//     const res = await fetch("/cart.js");
//     const cart = await res.json();
//     updateCartItemCounts(cart.item_count);
//     //DisplayAddingAnimation('block', 'Adding...');
//     // Update cart
//     await updateCartDrawer();
//     await updateShippingBar();
    
//     // Open cart drawer
    // openCartDrawer();
    // changePriceFormat();
    
//     setTimeout(() => {
//       DisplayAddingAnimation('none', 'Add to Bag');
//     },1000);
//   });
// });

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    console.log("form submit data")
    // Submit form with ajax
      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      })
      .then((response) => response.json())
      .then((response) => {})
      .catch((e) => {})
      .finally(async(e) => {
        await updateCartItemCounts(cart.item_count);
        
        await updateCartDrawer();
        await updateShippingBar();
        
        openCartDrawer();
        changePriceFormat();
        
         DisplayAddingAnimation('none', 'Add to Bag');
      });
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
    InitializeSlick();
  });
});


// -------------------- stickyAddToCart JS
var addtocartButton = document.querySelector('.product__atc-btn');
var stickyAddToCart = document.querySelector('.sticky-addtocart-desktop');

function isElementInViewport(el) {
  var getHeight = el.getBoundingClientRect();
  return (
    getHeight.top >= 0 && getHeight.left >= 0 &&
    getHeight.bottom <= (window.innerHeight || document.documentElement.clientHeight) && 
    getHeight.right <= (window.innerWidth || document.documentElement.clientWidth) 
  );
}

if(document.querySelector('body').classList.contains('product') || document.querySelector('body').classList.contains('product-giftcard') ){
  // ===============Product Page Sticky JS Start================ //

  window.addEventListener('DOMContentLoaded', function() {
    toggleStickyButton();
  });
  
  function toggleStickyButton() {
    if (stickyAddToCart) {
      if (isElementInViewport(addtocartButton)) {
        stickyAddToCart.style.display = 'none'; 
      } else {
        stickyAddToCart.style.display = 'block'; 
      }
    }
  }
  
  window.addEventListener('scroll', toggleStickyButton);
  window.addEventListener('resize', toggleStickyButton);
  
  
  // ------------------ Mobile Add to cart click on size dropdown 
  const Mobsticky = document.querySelector('.mobile-button_sticky');
  const stickyElement = document.querySelector('.prodcta-sticky_variant-column.prodcta-sticky_variant-list_mob');
  const stickyElementOverlay = document.querySelector('.overlay_sticky_addtocart');
  if (Mobsticky) {
    Mobsticky.addEventListener("click", (e) => {
        e.preventDefault();
    
        if (stickyElement) {
            stickyElement.classList.add('active');
        } 
        if (stickyElementOverlay) {
            stickyElementOverlay.classList.add('active');
        } 
    });
  }
  
  const clickOverlay =  document.querySelector('.overlay_sticky_addtocart');
  if (clickOverlay) {
    clickOverlay.addEventListener("click", (e) => {
      if (stickyElement) {
          stickyElement.classList.remove('active');
      } 
      if (stickyElementOverlay) {
          stickyElementOverlay.classList.remove('active');
      } 
    });
  }
  
  // ---------------------------stickyVariant for desktop
  const stickyVariant = document.querySelectorAll('.prodcta-sticky_variant-column li');
  if (stickyVariant) {
    stickyVariant.forEach((sticky) => {
        sticky.addEventListener("click", (event) => {
            stickyVariant.forEach(item => {
                item.classList.remove("active");
            });
    
            event.target.classList.add("active");
            const stickyVid = event.target.getAttribute("data-variantid");
            const stickyInput = document.querySelector('.sticky_variant_input');
            stickyInput.value = stickyVid;
    
            const stickyAddtext = document.querySelector('.prodcta-sticky_variant-list_desk button.add_to_cart span');
            const stickyAddDisable = document.querySelector('.prodcta-sticky_variant-list_desk button.add_to_cart');
            if (event.target.classList.contains('disabled')) {
               
              stickyAddtext.innerHTML = SoldOut;
              stickyAddDisable.setAttribute("disabled", "disabled");
            } else {
             
              stickyAddtext.innerHTML = Addtocart; 
               stickyAddDisable.removeAttribute("disabled");
             
            }
        });
    });
  }
  
  // ---------------------------stickyVariant for Mobile
  const MobstickyVariant = document.querySelectorAll('.prodcta-sticky_variant-list_mob li');
  if (MobstickyVariant) {
    MobstickyVariant.forEach((sticky) => {
        sticky.addEventListener("click", (event) => {
            MobstickyVariant.forEach(item => {
                item.classList.remove("active");
            });
    
            event.target.classList.add("active");
    
            const MobstickyVid = event.target.getAttribute("data-variantid");
    
            const MobstickyInput = document.querySelector('.prodcta-sticky_variant-list_mob .sticky_variant_input');
            MobstickyInput.value = MobstickyVid;
    
             const MobAddToCartForms = document.querySelectorAll('.mobile_form[action="/cart/add"]');
    
            MobAddToCartForms.forEach(form => {
                const submitButton = form.querySelector('[type="submit"]');
                if (submitButton) {
                    submitButton.click(); 
                }
            });
    
           const RstickyElement = document.querySelector('.prodcta-sticky_variant-column.prodcta-sticky_variant-list_mob');
          const RstickyElementOverlay = document.querySelector('.overlay_sticky_addtocart');
            
            if (RstickyElement) {
                RstickyElement.classList.remove('active');
            } 
            if (RstickyElementOverlay) {
                RstickyElementOverlay.classList.remove('active');
            }
    
           const stickyspinner = document.querySelector('.mobile-button.only-mobile .spinner');
          // console.log(stickyspinner,"stickyspinner")
         if (stickyspinner) {
            stickyspinner.style.display = 'block';
            }
    
          
        });
    });
  }
  
  // ===============Product Page Sticky JS End================ //
}

function InitializeSlick() {
  try {
    const slickElements = jQuery('.product-related__products');
    if (slickElements.length > 0 && typeof jQuery.fn.slick !== 'undefined') {
      // console.log('Initializing Slick carousel on elements:', slickElements);
      slickElements.slick({
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2
      });
    } else {
      // console.log('Slick library is not loaded or no elements found.');
    }
  } catch (error) {
    // console.log('Error in InitializeSlick:', error);
  }
}

function ensureSlickInitialized() {
  return new Promise((resolve, reject) => {
    try {
      if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
        InitializeSlick();
        resolve();
      } else {
        // Load jQuery and Slick dynamically if not loaded
        const script = document.createElement('script');
        script.src = "https://code.jquery.com/jquery-3.6.0.min.js";
        script.onload = () => {
          const slickScript = document.createElement('script');
          slickScript.src = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
          slickScript.onload = () => {
            try {
              InitializeSlick();
              resolve();
            } catch (slickError) {
              // console.log('Error initializing Slick:', slickError);
              
            }
          };
          slickScript.onerror = () => {
            // console.log('Error loading Slick library.');
           
          };
          document.head.appendChild(slickScript);
        };
        script.onerror = () => {
          // console.log('Error loading jQuery library.');
        
        };
        document.head.appendChild(script);
      }
    } catch (error) {
      // console.log('Error in ensureSlickInitialized:', error);    
    }
  });
}

document.addEventListener('DOMContentLoaded', async () => {
  await ensureSlickInitialized();
  
});


async function updateContentAndReinitializeSlick() {
 
  await updateCartDrawer();

  
  await ensureSlickInitialized();
}

try{
  if (document.querySelector('button.some-action')) {
    document.querySelector('button.some-action').addEventListener('click', async () => {
      await updateContentAndReinitializeSlick();
    });
  }  
}catch(error){
}
